module.exports = __webpack_public_path__ + "img/t2-teal.4e1e7e57.png";